import { IsFilterable, Filter } from "@/lib/filterable";
import { MrfiktivRegistrationDtoGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
class RegistrationBase implements MrfiktivRegistrationDtoGen {
  /**
   * firstname of registrationdocument
   * @example Max
   */
  firstname?: string;

  /**
   * name of registrationdocument
   * @example Mustermann
   */
  name?: string;

  /**
   * street of registrationdocument
   * @example Auf der Halle 25a
   */
  street?: string;

  /**
   * zipCode of registrationdocument
   * @example 49124
   */
  zipCode?: string;

  /**
   * city of registrationdocument
   * @example Georgsmarienhütte
   */
  city?: string;

  /**
   * huYear of registrationdocument
   * @example 2020
   */
  huYear?: string;

  /**
   * huMonth of registrationdocument
   * @example 05
   */
  huMonth?: string;

  /**
   * manufacturerNameCode of registrationdocument
   * @example 0005
   */
  manufacturerNameCode?: string;

  /**
   * manufacturerTypeCode of registrationdocument
   * @example AHT00025
   */
  manufacturerTypeCode?: string;

  /**
   * Defines the drive type of the vehicle, e.g if it is an electric (004) vehicle.
   * @example 004
   */
  driveTyp?: string;

  /**
   * identificationnumber of registrationdocument
   * @example WVWZZZ1JW2W057177
   */
  identificationnumber?: string;

  /**
   * numberplate of registrationdocument
   * @example OS-PT 678
   */
  numberplate?: string;

  /**
   * firstregistrationDay of registrationdocument
   * @example 05
   */
  firstregistrationDay?: string;

  /**
   * firstregistrationMonth of registrationdocument
   * @example 05
   */
  firstregistrationMonth?: string;

  /**
   * firstregistrationYear of registrationdocument
   * @example 2017
   */
  firstregistrationYear?: string;

  /**
   * manufacturerName of registrationdocument
   * @example Volkswagen
   */
  manufacturerName?: string;

  /**
   * manufacturerType of registrationdocument
   * @example Golf
   */
  manufacturerType?: string;

  /**
   * Defines the Class fo the vehicle, e.g PKW (M1), LNF (N1), BUS (M3)
   * @example M1
   */
  vehicleClass?: string;

  constructor(registration?: Partial<MrfiktivRegistrationDtoGen>) {
    this.firstname = registration?.firstname ?? "";
    this.name = registration?.name ?? "";
    this.street = registration?.street ?? "";
    this.zipCode = registration?.zipCode ?? "";
    this.city = registration?.city ?? "";
    this.huYear = registration?.huYear ?? "";
    this.huMonth = registration?.huMonth ?? "";
    this.manufacturerNameCode = registration?.manufacturerNameCode;
    this.manufacturerTypeCode = registration?.manufacturerTypeCode;
    this.driveTyp = registration?.driveTyp;
    this.identificationnumber = registration?.identificationnumber ?? "";
    this.numberplate = registration?.numberplate ?? "";
    this.firstregistrationDay = registration?.firstregistrationDay ?? "";
    this.firstregistrationMonth = registration?.firstregistrationMonth ?? "";
    this.firstregistrationYear = registration?.firstregistrationYear;
    this.manufacturerName = registration?.manufacturerName ?? "";
    this.manufacturerTypeCode = registration?.manufacturerTypeCode ?? "";
    this.vehicleClass = registration?.vehicleClass ?? "";
  }
}
type IRegistration = RegistrationBase;
const Registration = Filter.createForClass(RegistrationBase);

export { IRegistration, Registration };
